import { GetTipiDomandaTipoPubblicazione } from '@framework/api-client/api/inquiries/schemas/getTipiDomandaTipoPubblicazione.ts';
import { PermissionType } from '@framework/auth/permissions/PermissionType.ts';
import { usePermissions } from '@framework/auth/state/AuthSlice.tsx';
import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { useTranslation } from 'react-i18next';
import { theme } from '#theme';
import { InquiryAreaSelectInput } from './InquiryAreaSelectInput.tsx';
import { InquiryCategorySelectInput } from './InquiryCategorySelectInput.tsx';
import { InquiryCompetenceSelectInput } from './InquiryCompetenceSelectInput.tsx';
import { InquiryFilterFormFieldsLogic } from './InquiryFilterFormFieldsLogic.ts';
import { InquiryRecipientTypeSelectInput } from './InquiryRecipientTypeSelectInput.tsx';
import { InquiryScopeTreeSelectInput } from './InquiryScopeTreeSelectInput.tsx';
import { InquiryStateSelectInput } from './InquiryStateSelectInput.tsx';

export interface IInquiryFilterFormFieldsProps {}

/**
 * Campi del Form per la ricerca di domande FrontOffice.
 */
export function InquiryFilterFormFields(props: IInquiryFilterFormFieldsProps) {
  const showSearchPerScope = process.env.SEARCH_PER_SCOPE === 'true';
  const permissions = usePermissions();
  const { t } = useTranslation();

  return (
    <>
      <FormItem name="titolo" label={t('inquiry.titolo', 'Titolo')}>
        <TextInput name="titolo" placeholder={t('inquiry.titolo', 'Titolo')} />
      </FormItem>
      <FormItem
        name="tipoUtenteDestinatario"
        label={t('inquiry.destinatari', 'Destinatari')}
      >
        <InquiryRecipientTypeSelectInput
          allowClear
          mode="multiple"
          name="tipoUtenteDestinatario"
          placeholder={t('inquiry.destinatari', 'Destinatari')}
        />
      </FormItem>
      {showSearchPerScope && (
        <FormItem name="ambito" label="Ambito">
          <InquiryScopeTreeSelectInput name="ambito" placeholder="Ambito" />
        </FormItem>
      )}
      {InquiryFilterFormFieldsLogic.showCompetenceFilter() && (
        <FormItem
          name="idsCompetenze"
          label={t(
            'inquiry.competenza-territoriale',
            'Competenza Territoriale',
          )}
        >
          <InquiryCompetenceSelectInput name="idsCompetenze" />
        </FormItem>
      )}
      <FormItem name="categorie" label={t('inquiry.categorie', 'Categorie')}>
        <InquiryCategorySelectInput
          allowClear
          mode="multiple"
          name="categorie"
          placeholder={t('inquiry.categorie', 'Categorie')}
        />
      </FormItem>
      {InquiryFilterFormFieldsLogic.showStateSelectFilter() ? (
        <FormItem
          name="stato"
          label={t('inquiry.stato', 'Stato')}
          layout={{ removeLabelSpace: true }}
        >
          <InquiryStateSelectInput
            placeholder={t('inquiry.stato', 'Stato')}
            name={'stato'}
          />
        </FormItem>
      ) : (
        <FormItem
          name="soloAttive"
          label={null}
          layout={{ removeLabelSpace: true }}
        >
          <CheckboxInput name="soloAttive">
            {t('inquiry.solo-attive', 'Solo Attive')}
          </CheckboxInput>
        </FormItem>
      )}

      {theme.showAreaInquiryFilter && (
        <FormItem
          name="codiceAOO"
          label={t('inquiry.area-filter', 'Amministrazione')}
          layout={{ removeLabelSpace: true }}
        >
          <InquiryAreaSelectInput name="codiceAOO" />
        </FormItem>
      )}

      {permissions.has(PermissionType.TestinAccess) && (
        <FormItem
          name="tipoPubblicazione"
          label={t('inquiry.tipo-pubblicazione-filtro', 'Pubblicazione')}
        >
          <SelectInput
            name="tipoPubblicazione"
            options={[
              {
                label: t('inquiry.in-collaudo', 'In Collaudo'),
                value: GetTipiDomandaTipoPubblicazione.IN_COLLAUDO,
              },
              {
                label: t('inquiry.pubblicata', 'Pubblicata'),
                value: GetTipiDomandaTipoPubblicazione.PUBBLICATA,
              },
            ]}
          />
        </FormItem>
      )}
    </>
  );
}
